import { useEffect, useRef, useState } from 'react'
import type { ReactNode } from 'react'
import styles from './decks.module.css'

type Props = {
  label: string
  trigger: ReactNode
  triggerClassName?: string
  align?: 'start' | 'end'
  menu?: boolean
  children: ReactNode
}

export function DeckPopover({ label, trigger, triggerClassName, align = 'start', menu, children }: Props) {
  const [open, setOpen] = useState(false)
  const root = useRef<HTMLDivElement>(null)
  const button = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    if (!open) return
    const onPointer = (e: PointerEvent) => {
      if (!(e.target instanceof Element) || e.target.closest('dialog')) return
      if (!root.current?.contains(e.target)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || document.querySelector('dialog[open]')) return
      setOpen(false)
      button.current?.focus()
    }
    document.addEventListener('pointerdown', onPointer)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onPointer)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div ref={root} className={styles.popRoot}>
      <button ref={button} type="button" className={triggerClassName} aria-label={label} aria-haspopup={menu ? 'menu' : 'dialog'} aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        {trigger}
      </button>
      {open && (
        <div className={`${styles.pop} ${menu ? styles.popMenu : ''}`} data-align={align} role={menu ? 'menu' : 'dialog'} aria-label={label} onClick={menu ? () => setOpen(false) : undefined}>
          {children}
        </div>
      )}
    </div>
  )
}
